import { GoChevronDown } from "react-icons/go";
import profile from "../../images/Damas_univ.png";
import { fileURL, useClose, useFetch } from "../../ApiS";
import { Link } from "react-router-dom";

interface ProfileProps {
  now?: boolean;
  title?: string;
  pushSearch?: () => void;
  hideAll?: boolean;
  setSure: (value: boolean) => void;
}

const Profile: React.FC<ProfileProps> = ({
  now,
  title,
  pushSearch,
  hideAll,
  setSure,
}) => {
  const { open, setOpen, mouse } = useClose();
  const { data } = useFetch("admin/profile", "profile" );

  return (
    <>
      <div ref={mouse} className="relative cursor-pointer">
        <div
          className={`w-full h-[40px] mt-1  text-base max-sm:mx-auto max-md:text-base bg-[#F6F8F9] rounded-xl text-center shadow-Third shadow-sm font-bold flex justify-center gap-4 items-center  px-1 text-black`}
          onClick={() => setOpen(!open)}
        >
          <img
            src={fileURL + data?.data?.images[0]?.image}
            className="w-8 h-8 rounded-full max-sm:w-4 max-sm:h-4"
          />
          <div className="max-md:hidden"> {data?.data?.first_name} {data?.data?.last_name} </div>
          <GoChevronDown size={20} />
        </div>

        <div
          className={`${
            open
              ? "absolute w-full top-12 transition-all   z-20  bg-[#F6F8F9] rounded-md text-center   text-black  "
              : "hidden"
          }`}
        >
          {hideAll ? (
            ""
          ) : (
            <>
              <Link to="/profile">
                <div className="border-b-2 p-2 cursor-pointer max-sm:text-[10px]">
                  ملفي الشخصي
                </div>
              </Link>
              <div className="border-b-2 p-2 cursor-pointer  max-sm:text-[10px]">
                الاعدادات
              </div>
              <div
                className="border-b-2 p-2 cursor-pointer  max-sm:text-[10px]"
                onClick={() => setSure(true)}
              >
                تسجيل خروج
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
